var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"horizontal-scroll",style:({ '--duration': _vm.duration / 1000 + 's', '--delay': _vm.duration / 2000 + 's', '--reverse': _vm.reverse ? 'reverse' : 'normal' })},[_c('div',{staticClass:"animate-container"},[_vm._t("default")],2),_c('div',{staticClass:"animate-container copy"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }